import React from "react";
import { IBillingValues, SelectItem } from "../types/locationTypes";
import { useStylesForForms } from "./billingHelpers";
import BillingDateField from "./BillingDateField";
import { Button, MenuItem, Select, TextField } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Alert from "@material-ui/lab/Alert";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import ErrorMessage from "../../shared/messages/ErrorMessage";
interface BillingFormType5Props {
  billingValuesObj: IBillingValues;
  handleSetBillingValuesObj: any;
  disabled: boolean;
  retainerIntervals: SelectItem[];
  CheckDecisionRule: any;
  checkRules: any;
  errormessage: any;
}
const billingfrequency = [
  {
    id: 0,
    text: "Choose",
    selected: true,
  },
  {
    id: 1,
    text: "Weekly",
    selected: false,
  },
  {
    id: 2,
    text: "Fortnightly",
    selected: false,
  },
  {
    id: 3,
    text: "Monthly",
    selected: false,
  },
  {
    id: 4,
    text: "Quarterly",
    selected: false,
  },
  {
    id: 5,
    text: "Bi-annually",
    selected: false,
  },
  {
    id: 6,
    text: "Annually",
    selected: false,
  },
];
const contractedentity = [
  {
    id: 0,
    text: "Choose",
    selected: true,
  },
  {
    id: 1,
    text: "Customer",
    selected: false,
  },
  {
    id: 2,
    text: "Location",
    selected: false,
  },
];

const BillingFormType5: React.FC<BillingFormType5Props> = ({
  billingValuesObj,
  handleSetBillingValuesObj,
  disabled,
  retainerIntervals,
  CheckDecisionRule,
  checkRules,
  errormessage,
}) => {
  const classes = useStylesForForms();
  
  const handleTest = () => {
    CheckDecisionRule();
  };

  return (
    <div className={classes.flexContainer}>
      <div>
        <hr className={classes.separator} />
      </div>
      <div className={classes.row}>
        <BillingDateField
          title="COMMENCEMENT DATE"
          description=""
          parentClasses={classes}
          disabled={disabled}
          value={billingValuesObj.commencementDate}
          setValue={(newValue: string | null) => {
            handleSetBillingValuesObj("commencementDate", newValue);
          }}
        />
        <div>
          <div className={classes.formControlLabel}>BILLING FREQUENCY</div>
          <Select
            classes={{ root: classes.textFieldInput }}
            style={{ width: 230, marginTop: 10 }}
            IconComponent={KeyboardArrowDownIcon}
            variant="outlined"
            displayEmpty
            disabled={disabled}
            value={billingValuesObj.billingRuleFrequency}
            onChange={(e) => {
              handleSetBillingValuesObj("billingRuleFrequency", e.target.value);
            }}
          >
            {billingfrequency.map((item) => (
              <MenuItem
                selected={item.selected}
                key={item.id}
                defaultValue={item.id}
                value={item.id}
              >
                {item.text}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
      <div className={classes.row}>
        <div>
          <div className={classes.formControlLabel}>BILLING RULE</div>
          <TextField
            InputProps={{
              classes: { root: classes.textFieldInput },
              style: { width: 300 },
            }}
            variant="outlined"
            disabled={disabled}
            value={billingValuesObj.billingRuleID}
            onChange={(e: any) => {
              handleSetBillingValuesObj("billingRuleID", e.target.value);
            }}
          />
        </div>
        <div>
          <div className={`${classes.formControlLabel} version`}>VERSION</div>
          <TextField
            className="version"
            InputProps={{
              classes: { root: classes.textFieldInput },
              //style: { width: 210 },
            }}
            variant="outlined"
            disabled={disabled}
            value={billingValuesObj.billingRuleVersion}
            onChange={(e: any) => {
              handleSetBillingValuesObj("billingRuleVersion", e.target.value);
            }}
            placeholder="Latest"
          />
        </div>
        <div>
          <div className={classes.formControlLabel}>&nbsp;</div>
          <div className={classes.testBox}>
            <Button
              type="button"
              onClick={handleTest}
              className={classes.testBtn}
              variant="contained"
              color="primary"
            >
              Test
            </Button>
            {checkRules && (
              <div className={classes.testMsg}>
                {checkRules !== "null" ? checkRules : ""}
              </div>
            )}
            {/* {errormessage && (
              <div className={classes.testMsg} style={{ color: "red" }}>
                {errormessage !== "null" ? errormessage : ""}
              </div>
            )} */}
          </div>
        </div>
      </div>
      <div className={classes.row}>
        <Alert
          variant="filled"
          icon={<ReportProblemOutlinedIcon />}
          severity="error"
          classes={{ root: classes.alertRoot }}
          style={{ display: errormessage ? "flex" : "none" }}
        >
          {errormessage}
        </Alert>
      </div>
      <div className={classes.row}>
        <div>
          <BillingDateField
            title="AUTOMATED PRICING UNAVAILABLE BEFORE.."
            description="Complete this field if transfers prior to a certain date don’t contain enough data to be priced automatically"
            parentClasses={classes}
            disabled={disabled}
            value={billingValuesObj.automatedPricingUnavailableBefore}
            setValue={(newValue: string | null) => {
              handleSetBillingValuesObj(
                "automatedPricingUnavailableBefore",
                newValue
              );
            }}
            className="automatedPricing"
          />
        </div>
        <div>
          <div className={classes.formControlLabel}>CONTRACTED ENTITY</div>
          <Select
            classes={{ root: classes.textFieldInput }}
            style={{ width: 230, marginTop: 10 }}
            IconComponent={KeyboardArrowDownIcon}
            variant="outlined"
            displayEmpty
            disabled={disabled}
            value={billingValuesObj.contractedEntity}
            onChange={(e) => {
              handleSetBillingValuesObj("contractedEntity", e.target.value);
            }}
          >
            {contractedentity.map((item) => (
              <MenuItem
                selected={item.selected}
                key={item.id}
                defaultValue={item.id}
                value={item.id}
              >
                {item.text}
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </div>
  );
};

export default BillingFormType5;
